
// Expedient Question

import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
// import "./RerouteModalStyles.css";
import { expediteQuestion } from "../../../API/api";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
const textStyles1 = {
   fontSize: "16px",
   color: "#2A364A",
   lineHeight: "24px",
   fontWeight: "500",
   wordBreak: 'break-word', overflowWrap: 'break-word',
   textAlign: "left"
};
const modalTitleStyle = {
    color: "rgb(42, 54, 74)",
    fontSize: "20px",
    fontFamily: "Helvetica",
  };
export default function ExpediteQuestionModal() {
   const [isLoading, isLoaded] = useState(false);
   const successMsg = (message) => {
       return (
           <>
               <span style={{ fontSize: "12px" }}>{message === undefined ? "User has expedited the process to get an answer successfully" : message}</span>
           </>
       );
   };
   const modalState = useSelector((state) => state.domain);
   const expertRecordsState = useSelector((state) => state.expertRecord);
   const dispatch = useDispatch();
   const currentPath = useLocation();
   const navigate = useNavigate();
   const { advanceFilterModalToggle, cmrDetailedRefresh, cmrIsGoBack } = bindActionCreators(Actions, dispatch);
   const onClickButtons = () => {
       isLoaded(true);
       const payload = {
           questionUuidStr: expertRecordsState.selectedDataDetailed.questionUuid,
           expertUuidStr: expertRecordsState.selectedDataDetailed.expertUuid
       }
       expediteQuestion(payload).then(res => {
           if (res === undefined) {
               advanceFilterModalToggle({ bool: false, value: "" });
               return;
           }
           if (res.data.success) {
               cmrIsGoBack(false)
               toast.success(successMsg(res.data.message), {
                   position: toast.POSITION.TOP_RIGHT,
               });
               cmrDetailedRefresh('g')
               advanceFilterModalToggle({ bool: false, value: "" });
               isLoaded(false);
           }
       });
   }
   return (
       <>


           {/* <Modal show={modalState.modalState}
               onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
               centered={true}
               size={"lg"}
               style={{ marginTop: "-50px" }}
           // scrollable={true}
           >
               <ModalBody>
                   <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
                       <div className="container">
                           <p style={{ fontSize: '16px', fontWeight: '300' }}>Are you sure you want to Expedite this Open Entry?</p>
                           <p style={{ fontSize: '14px', fontWeight: '300' }}>The Expert will no longer be able to view this question in his Open Queue.</p>


                           {!isLoading && <div>
                               <button className="cancelBtn" onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;<button className="rerouteBtn" onClick={() => onClickButtons()}>Yes</button>
                           </div>}
                           {isLoading &&
                               <div>
                                   <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Processing...</button>
                               </div>}
                       </div>
                   </div>
               </ModalBody>
           </Modal> */}


           <Modal
               show={modalState.modalState}
               onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
               centered={true}
               size={"lg"}
           // dialogClassName={styles.modalDialog}
           >
               <Modal.Header closeButton>


                   <Modal.Title style={modalTitleStyle}>
                       Are you sure you want to Expedite this Open Entry?
                   </Modal.Title>
               </Modal.Header>
               <Modal.Body>
                   {/* <p style={{ fontSize: '16px', fontWeight: '300' }}>Are you sure you want to Expedite this Open Entry?</p> */}
                   <div style={{ display: "flex", justifyContent: "center" }}>
                       <p style={textStyles1}>The Expert will no longer be able to view this question in his Open Queue.</p>
                   </div>








                   <div
                       style={{
                           display: "flex",
                           // color: "grey",
                           fontSize: "16px",
                           alignItems: "baseline",
                           justifyContent: 'center',
                           // marginTop: '10px',
                           fontWeight: '300',
                           gap: 5,
                           marginRight: "0px",
                           marginTop:"-6px"
                       }}
                   >
                       <div
                           style={textStyles1}
                       >
                           {/* Expert: */}
                       </div>
                       <div style={{ width: "200px", }}>
                           {!isLoading && <div className="mt-2 mb-2" style={{ textAlign: 'center' }}>
                               <button
                                   style={{
                                       padding: '8px 12px 8px 12px',
                                       borderRadius: '6px',
                                       fontSize: '14px',
                                       lineHeight: '24px',
                                       fontWeight: 400,
                                       boxShadow: ' 0px 1px 2px 0px #1018280D',
                                       color: '#2A364A',
                                       border: '1px solid  #fff',
                                       height: '40px',
                                       minWidth: '88px',
                                       background: " #F6F7F8",
                                       marginBottom: '14px',
                                       fontWeight: 400,
                                       border: " 1px solid #E0E2E6",
                                       marginRight:"10px"


                                       //  font-weight: 400;          
                                   }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;
                               {/* <button className="rerouteBtn" onClick={() => onClickSubmit()} disabled={expert.length === 0 ? true : false}>Route</button> */}
                               <button
                                   style={{
                                       padding: '8px 12px 8px 12px',
                                       borderRadius: '6px',
                                       fontSize: '14px',
                                       lineHeight: '24px',
                                       fontWeight: 400,
                                       boxShadow: '0px 1px 2px 0px #1018280D',
                                       color: '#FFFFFF',
                                       border: '1px solid  #fff',
                                       height: '40px',
                                       minWidth: '88px',
                                       background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                       marginBottom: '14px',
                                       marginTop: "15px",
                                     
                                   }}
                                   // disabled={expert.length === 0 ? true : false}
                                   onClick={() => onClickButtons()}
                               >
                                   Yes
                               </button>
                           </div>}
                           {isLoading &&
                               <div className="mt-2 mb-2" style={{ textAlign: 'center' }}>
                                   <button style={{
                                       padding: '8px 12px 8px 12px',
                                       borderRadius: '6px',
                                       fontSize: '14px',
                                       lineHeight: '24px',
                                       fontWeight: 400,
                                       boxShadow: '0px 1px 2px 0px #1018280D',
                                       color: '#FFFFFF',
                                       border: '1px solid  #fff',
                                       height: '40px',
                                       minWidth: '88px',
                                       background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                       marginBottom: '14px',
                                       marginTop: "15px"
                                   }} disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Processing...</button>
                               </div>}


                       </div>
                   </div>
                   {/* <div
             className="searchsuggestionModal"
             style={{ textAlign: "end" }}
           >
             <button
               style={{
                 padding: '8px 12px 8px 12px',
                 borderRadius: '6px',
                 fontSize: '14px',
                 lineHeight: '24px',
                 fontWeight: 400,
                 boxShadow: '0px 1px 2px 0px #1018280D',
                 color: '#FFFFFF',
                 border: '1px solid  #fff',
                 height: '40px',
                 minWidth: '88px',
                 background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                 marginBottom: '14px',
                 marginTop: "15px"
               }}
             // onClick={() => onClickSubmit()}
             >
               Submit
             </button>
           </div> */}
               </Modal.Body>
           </Modal>
       </>
   )
}




